<template>
  <div>
    <b-form-group
      :label="$t('servers.network')"
      :state="validateState('network')"
    >
      <multiselect
        v-model="form.network"
        :options="networkList"
        track-by="id"
        label="name"
        :loading="loading"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('servers.network')"
        :show-no-results="false"
      />
    </b-form-group>

    <InfoBox v-if="form.network">
      <div>
        <h5>{{ form.network.name }}</h5>
        <ul class="ul-list-styled pl-3">
          <li>
            <b>{{ $t('global.networkType') }} :</b>
            {{ form.network.network_type }}
          </li>
          <li>
            <b>{{ $t('global.ipAddress') }} :</b> {{ form.network.ip_addr }}
          </li>
          <li>
            <b>{{ $t('global.ipAddressRangeStart') }} :</b>
            {{ form.network.ip_range_start }}
          </li>
          <li>
            <b>{{ $t('global.ipAddressRangeEnd') }} :</b>
            {{ form.network.ip_range_end }}
          </li>
          <li>
            <b>{{ $t('global.gateway') }} :</b> {{ form.network.gateway }}
          </li>
          <li>
            <b>{{ $t('global.subnet') }} :</b> {{ form.network.subnet }}
          </li>
        </ul>
      </div>
    </InfoBox>

    <Checkbox
      label="servers.reserveIP"
      id="reserve"
      v-model="form.reserve"
      class="mb-3"
    />

    <Checkbox
      label="servers.assignRandomIP"
      id="randomip"
      v-model="form.randomip"
      class="mb-3"
      defaultValue="true"
    />

    <Input
      label="global.ipAddress"
      id="ip_addr"
      v-if="form.randomip == false"
      placeholder="examples.ip"
      v-model="form.ip_addr"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'IpCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        network: '',
        reserve: '',
        randomip: true,
        ip_addr: '',
      },
      networkList: [],
      loading: false,
    }
  },
  validations: {
    form: {
      network: {
        required,
      },
    },
  },
  created() {
    this.getNetworks()
  },
  methods: {
    getNetworks() {
      this.getNetworkList().then((res) => {
        this.setNetworkList(res)
      })
    },
    getNetworkList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        //ApiService.get(`iaas/networks?virtualNetworks=1&position=id|desc`)
        ApiService.get(`iaas/networks?position=id|desc`)
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setNetworkList(res) {
      if (res && res.data && res.data.length > 0) {
        this.networkList = res.data
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        network_ref: this.form.network.id,
        is_reserved: this.form.reserve,
        allow: 1,
      }

      if (this.form.ip_addr) params.ip_addr = this.form.ip_addr

      ApiService.post(`packetbender/ip`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
